module.exports = __webpack_public_path__ + "static/media/kiss-beam.ccf4639d.svg";